import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import ar from './locales/ar.json';

export const supportedLanguages = ['fr', 'ar'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const languageNames: Record<SupportedLanguage, string> = {
  fr: 'Fran\u00e7ais',
  ar: '\u0627\u0644\u0639\u0631\u0628\u064a\u0629',
};

export const languageFlags: Record<SupportedLanguage, string> = {
  fr: '\ud83c\uddeb\ud83c\uddf7',
  ar: '\ud83c\uddf9\ud83c\uddf3',
};

// RTL languages
export const rtlLanguages: SupportedLanguage[] = ['ar'];

export function isRtlLanguage(lang: string): boolean {
  return rtlLanguages.includes(lang as SupportedLanguage);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      ar: { translation: ar },
    },
    fallbackLng: 'fr',
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'mawkaa-language',
    },
  });

// Update document direction when language changes
i18n.on('languageChanged', (lng) => {
  const dir = isRtlLanguage(lng) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
});

// Set initial direction
if (typeof document !== 'undefined') {
  const dir = isRtlLanguage(i18n.language) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = i18n.language;
}

export default i18n;
